import { Img } from 'components/common/atoms/img'

interface Props extends IElement {
  id?: string
  src: string
}

export const ImageIcon: React.FC<Props> = ({ id, src, ...restProps }) => (
  <Img src={src} alt={`icon${id ? `-${id}` : ''}`} id={id} {...restProps} />
)
